import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "open", "transitioning", "zIndex"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TwoWayTransition from '../../transitions/TwoWayTransition';
import { ModalTransitionContextProvider } from '../../context/ModalTransitionContext';
import { PANEL_TRANSITION_TIMING } from 'HubStyleTokens/times';
import { JUPITER_LAYER } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const PanelTransitionWrapper = styled(_ref => {
  let {
      open,
      transitioning
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TwoWayTransition.PlainWrapper, Object.assign({
    "data-component-name": "UIPanel",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "PanelTransition__PanelTransitionWrapper",
  componentId: "a2d2sg-0"
})(["transition-property:", ";transition-duration:", "ms;transform:", ";position:fixed;top:0;bottom:0;z-index:", ";", ";"], ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', ({
  duration
}) => duration, ({
  align,
  open
}) => {
  if (open) return 'translateX(0%)';
  return align === 'left' ? 'translateX(-100%)' : 'translateX(100%)';
}, ({
  zIndex
}) => zIndex, ({
  align
}) => align === 'right' ? 'right: 0;' : 'left: 0;');
export default function PanelTransition(props) {
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
    ContextProvider: ModalTransitionContextProvider,
    transitionOnMount: true
  }));
}
PanelTransition.propTypes = {
  align: PropTypes.oneOf(['left', 'right']).isRequired,
  duration: PropTypes.number.isRequired,
  Wrapper: PropTypes.elementType.isRequired,
  zIndex: PropTypes.string
};
PanelTransition.defaultProps = {
  align: 'right',
  duration: parseInt(PANEL_TRANSITION_TIMING, 10),
  Wrapper: PanelTransitionWrapper,
  zIndex: JUPITER_LAYER
};
PanelTransition.displayName = 'PanelTransition';